import {createContext, useContext, useEffect, useState} from "react";
import {useLegend} from "../../hooks";
import {AuthenticationContext} from "../auth";

const LegendContext = createContext({
    legend: {}
})

function LegendProvider({children}){
    const {isAuthenticated} = useContext(AuthenticationContext);
    const rawData = useLegend(isAuthenticated);
    const [legend, setLegend] = useState({});

    useEffect(()=>{
        let newLegend = {};
        rawData?.forEach((dataElement)=> {
            let dictionary = {};
            dataElement.codes?.forEach((code) => {
                dictionary[code.code_name] = code.description;

            });
            newLegend[dataElement.column_name] = dictionary;
        });
        setLegend(newLegend);
        console.log(newLegend)
    }, [rawData])

    const context = {legend};

    return <LegendContext.Provider value={context}>
        {children}
    </LegendContext.Provider>
}

export {LegendContext, LegendProvider}